module.exports = __webpack_public_path__ + "img/drive04.030d3135.png";